import React, {useEffect, useRef} from "react";
import {autoUpdate, flip, offset, shift, size, useFloating} from "@floating-ui/react";
import {ContextMenu} from "./ContextMenu";
import {ThreeDotsIcon} from "../../../icons/ThreeDotsIcon";
import {LoadingSpinner} from "../../../icons/LoadingSpinner";
import {useOutsideClick} from "../../../../hooks/useOutsideClick";

export const RecordOptionsButton = ({
                                        onClick,
                                        style,
                                        contextWindowActive,
                                        contextPositions,
                                        className = 'record-context-actions-button',
                                        dotsFill,
                                        isLoading,
                                    }) => {
    const referenceRef = useRef(null);
    const {refs, floatingStyles, placement, update} = useFloating({
        placement: 'bottom-start',
        open: contextWindowActive,
        middleware: [
            offset(8),
            flip({fallbackPlacements: ['top-start', 'bottom-end', 'top-end']}),
            shift({padding: 8}),
            size({
                padding: 8,
                apply({availableWidth, availableHeight, elements}) {
                    Object.assign(elements.floating.style, {
                        maxWidth: `${availableWidth}px`,
                        maxHeight: `${availableHeight}px`,
                        overflow: 'auto',
                    });
                },
            }),
        ],
        whileElementsMounted: autoUpdate,
    });

    useOutsideClick([referenceRef, refs.floating], onClick, contextWindowActive);

    useEffect(() => {
        refs.setReference(referenceRef.current);
    }, [refs]);


    const handleClick = () => {
        if (isLoading) return;
        onClick();
        requestAnimationFrame(() => update());
    };

    return (
        <div className='relative-container'>
            <div ref={referenceRef}
                 className={className}
                 style={style}
                 tabIndex={-1}
                 onClick={handleClick}>
                {isLoading ? <LoadingSpinner buttonMode/> : <ThreeDotsIcon fill={dotsFill}/>}
            </div>

            {contextWindowActive && (
                <ContextMenu
                    positions={contextPositions}
                    floatingRef={refs.setFloating}
                    floatingStyles={floatingStyles}
                    placement={placement}
                />
            )}
        </div>
    );
}